
import { Row,Col, Card, CardHeader, CardBody, Button, Modal, ModalBody, ModalFooter, ModalHeader, Container } from 'reactstrap';
import React, {Component} from 'react';
import ScaleLoader from "react-spinners/ScaleLoader";

var rmsApiProxyRetry = require('../../../../../utils/api/rmsApiProxyRetry');
var dateUtil = require('../../../../../utils/dateUtil/dateUtil');
var formatter = require('../../../../../utils/formatter/formatter.js');

const translator = require('../../../../../utils/translator/translator');

class CreditBookDialogue extends Component 
{
    constructor(props) 
    {
        super(props);

        this.state = {};
        this.state.stage = 0;
        this.state.waitMessage = translator.getLabel("please_wait_loading_credit_books");
        this.state.creditBooks = [];

        this.onPayment = this.onPayment.bind(this);

        this.loadCreditBooks();
    }

    render() 
    {
        let component = null;
        if (this.state.stage == 0)
            component = this.renderWaitMessage();
        else if (this.state.stage == 1)
            component = this.renderCreditBooks();

        return(
                <Modal isOpen={true} centered animation={false} fade={false} size="lg" style={{maxWidth: '1400px', width: '80%'}}>
                  <ModalBody style={{border:'2px solid #181818'}}>
                    <div>
                        {this.renderErrorMessage()}
                    </div>
                    <div style={{height:'60vh'}}>
                            {component}
                      </div>
                  </ModalBody>
                  <ModalFooter style={{border:'1px solid #181818'}}>
                    <div className="w-100 d-flex flex-row justify-content-end">
                        <Button size="lg" color="danger" className="btn-secondary" style={{marginRight:'8px'}} onClick={this.props.onClose}>
                                {translator.getLabel("cancel")}
                        </Button>
                        <Button disabled={!this.canContinueWithPayment()} size="lg" color="primary" className="btn-primary" onClick={this.onPayment}>
                                {`${translator.getLabel("confirm_payment")}:  ${formatter.convertToCurrencyFormat(this.props.transactionAmount)}`}
                        </Button>
                    </div>
                  </ModalFooter>
            </Modal>);
    }

    renderErrorMessage()
    {
        if (this.state.error == null)
            return;

        const hStyle = { color: '#D70040' };
        return (<div align="middle">
                    <h4 style={hStyle}>{this.state.error}</h4>
                    <hr/>
                </div>);
    }

    renderWaitMessage()
    {
        return <div style={{position:'fixed', top:'50%', left:'50%', userSelect:'none', transform:'translate(-50%, -50%)'}}>
                    <table width="100%" height="100%">
                        <tr align="middle">
                                <ScaleLoader
                                        height={50}
                                        width={6}
                                        color={"#808080"}
                                        loading={true}/>
                        </tr>
                        <tr align="middle" style={{fontSize:'1.3rem', color:'#585858'}}>
                            <h4 className="text-muted">{this.state.waitMessage}</h4>
                        </tr>
                    </table>
                </div>
    }

    renderCreditBooks()
    {
        if (this.state.creditBooks.length <= 0)
        {
            return (<div style={{position:'fixed', top:'50%', left:'50%', userSelect:'none', transform:'translate(-50%, -50%)'}}>
                        <h4 className="text-muted">{translator.getLabel("no_credit_books_found")}</h4>
                    </div>);
        }

        var creditBookComponents = [];
        this.state.creditBooks.filter(creditBook => !creditBook.isDisabled).forEach (creditBook =>
        {
            if (this.state.selectedCreditBook == creditBook)
                creditBookComponents.push(<div style={{border:'1px solid #181818', background:'#B0B0B0', color:'#303030', textAlign:'center', padding:'10px', userSelect:'none', cursor:'pointer'}}>
                                            {creditBook.name}
                                         </div>)
            else
                creditBookComponents.push(<div style={{border:'1px solid #181818', textAlign:'center', padding:'10px', userSelect:'none', cursor:'pointer'}}
                                            onClick={()=>
                                            {
                                                this.state.selectedCreditBook = creditBook;
                                                this.state.selectedCreditAccount = null;
                                                this.setState({});
                                            }}>
                                            {creditBook.name}
                                         </div>)

        })

        var creditAccountComponents = [];
        if (this.state.selectedCreditBook != null)
        {
            this.state.selectedCreditBook.accounts.filter(account => !account.isDisabled).forEach (creditAccount =>
            {
                if (this.state.selectedCreditAccount == creditAccount)
                    creditAccountComponents.push(<div style={{border:'1px solid #181818', background:'#B0B0B0', color:'#303030', textAlign:'center', padding:'10px', userSelect:'none', cursor:'pointer'}}>
                                                {creditAccount.name}
                                            </div>)
                else
                    creditAccountComponents.push(<div style={{border:'1px solid #181818', textAlign:'center', padding:'10px', userSelect:'none', cursor:'pointer'}}
                                                    onClick={()=>
                                                    {
                                                        this.state.selectedCreditAccount = creditAccount;
                                                        this.setState({});
                                                    }}>
                                                    {creditAccount.name}
                                                </div>)

            })
        }

        return <table style={{width:'100%'}}>
                    <tr>
                        <td style={{width:'50%'}}>
                            <div style={{border:'1px solid #181818'}}>
                                <div style={{background:'#383838', color:'#FFFFFF', padding:'5px', textAlign:'center', marginBottom:'3px'}}>
                                    <h3>{translator.getLabel("credit_books")}</h3>
                                </div>
                                <div style={{height:'52vh', overflowY:'auto', margin:'0px'}}>
                                    {creditBookComponents}
                                </div>
                            </div>
                        </td>
                        <td style={{width:'50%'}}>
                            <div style={{border:'1px solid #181818'}}>
                                <div style={{background:'#383838', color:'#FFFFFF', padding:'5px', textAlign:'center', marginBottom:'3px'}}>
                                    <h3>{translator.getLabel("credit_accounts")}</h3>
                                </div>
                                <div style={{height:'52vh', overflowY:'auto', margin:'0px'}}>
                                    {creditAccountComponents}
                                </div>
                            </div>
                        </td>
                    </tr>
                </table>
    }

    loadCreditBooks()
    {
        let resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/creditBooks/chartOfAccounts`;
        rmsApiProxyRetry.get(resource)
        .then(creditBooks =>
        {
            if (creditBooks == null)
                creditBooks = [];

            this.state.creditBooks = creditBooks;
            this.state.error = null;
            this.state.selectedCreditBook = null;
            this.state.selectedCreditAccount = null;
            this.state.stage = 1;

            if (this.state.creditBooks.length > 0)
            {
                this.state.selectedCreditBook = this.state.creditBooks[0];
            }
            this.setState({});
        }, error =>
        {
            this.state.creditBooks = [];
            this.state.error = error;
            this.state.stage = 1;
            this.state.selectedCreditBook = null;
            this.state.selectedCreditAccount = null;
            this.setState({});
        });
    }

    canContinueWithPayment()
    {
        return this.state.selectedCreditBook != null && this.state.selectedCreditAccount != null;
    }

    async onPayment()
    {
        try
        {
            this.state.stage = 0;
            this.state.error = null;
            this.state.waitMessage = translator.getLabel("performing_transaction"); 
            this.setState({});

            let transaction = {};
            transaction.reference = this.props.transactionReference;
            transaction.amount = this.props.transactionAmount;
            transaction.dateTime = dateUtil.getNow();
            transaction.type = 'Credit';

            let resource = `${rmsApiProxyRetry.getOrgContextToUrl()}/accounts/creditBooks/${this.state.selectedCreditBook.id}/${this.state.selectedCreditAccount.id}`;
            var response = await rmsApiProxyRetry.post(resource, transaction); 

            if (response.status == "approved")
            {
                this.props.onCompletion(this.state.selectedCreditBook, this.state.selectedCreditAccount, response);
            }
            else
            {
                this.state.error = translator.getLabel("transaction_is_declined");
                this.state.stage = 1;
                this.setState({});
            }

        }
        catch(error)
        {
            this.state.error = error;
            this.state.stage = 1;
            this.setState({});
        }
    }
}

export default CreditBookDialogue;